import { Box, Grid, TextField } from "@mui/material";
import * as React from "react";
import { ConfirmationDialogResult } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import * as store from "../../../framework/customStore";
import { SaveDataObj } from "../../../framework/saveData";
import * as documentService from "../../../models/services/documentService";
import * as storeActions from "../../../models/store/storeActions";
import { Dialog } from "../../framework/Dialog/Dialog";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { DialogButtons } from "source/components/framework/Dialog/DialogButtons";
import { IFolderTreeNode } from "source/models/document/folderTreeNode";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";

export interface IDocumentFolderNewDialogProp {
    companyId: string;
    folder: IFolderTreeNode;
    onOk: (newFolderId: string) => void;
    onCancel: () => void;
}

export interface IDocumentFolderNewDialogState {
    code: string;
    comment: string;
}

export class DocumentFolderNewDialog extends React.Component<IDocumentFolderNewDialogProp, IDocumentFolderNewDialogState> {
    private orgStateHash: string = "";

    constructor(props: IDocumentFolderNewDialogProp) {
        super(props);
        this.state = {
            code: "",
            comment: ""
        };
    }

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "code") {
            this.setState({ code: value });
        } else if (name === "comment") {
            this.setState({ comment: value });
        }
    };

    getSaveDataFromState = async (props: IDocumentFolderNewDialogProp, state: IDocumentFolderNewDialogState): Promise<SaveDataObj> => {
        const result = new SaveDataObj();
        result.append("folderId", props.folder.id);
        result.append("companyId", props.companyId);
        result.append("code", state.code);
        result.append("comment", state.comment);
        return result;
    };

    checkErrors = (): Promise<boolean> => {
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            if (!state.code) {
                store.customStore.dispatch(storeActions.showErrorMessage(Translations.NameMustBeDefined));
                return resolve(false);
            }
            return resolve(true);
        });
    };

    saveToDb = async (): Promise<SaveSuccess> => {
        const props = this.props;
        const state = this.state;
        if (!await AppUtils.validate(this.checkErrors)) return null;
        const saveData = await this.getSaveDataFromState(props, state);
        //Call server
        return await AppUtils.callService(() => documentService.addFolder(saveData.obj));
    };

    handleSave = async () => {
        const result = await this.saveToDb();
        if (!result) return;
        this.props.onOk(result.id);
    };

    handleCancel = async () => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel((await this.getSaveDataFromState(props, state)).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.handleSave();
        } else {
            props.onCancel();
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Dialog
                id="newFolderDialog"
                maxWidth="sm"
                title={Translations.AddFolder + " (" + props.folder.name + ")"}
                body={
                    <Box display="flex" flexDirection="column">
                        <GridRow>
                            <Grid item sm={12}>
                                <FormField title={Translations.FolderName} required margin={0}>
                                    <TextField name="code" title={Translations.FolderName} inputProps={{ maxLength: 248 }} value={state.code} required={true} onChange={this.handleChange} size="small" fullWidth />
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormField title={Translations.Description} fullWidth>
                                    <TextField name="comment" title={Translations.Description} inputProps={{ maxLength: 1000 }} value={state.comment} onChange={this.handleChange} multiline rows={5} size="small" fullWidth />
                                </FormField>
                            </Grid>
                        </GridRow>
                    </Box>
                }
                actions={
                    <Box display="flex" justifyContent="end" width="100%">
                        <DialogButtons
                            isNew={true}
                            onCancel={this.handleCancel}
                            onSave={this.handleSave}
                        />
                    </Box>
                }
                onClose={this.handleCancel}
            />
        );
    }
}